<template lang="pug">
    div
        AppNav
        h1 Page de connection
        p.lead Bienvenue dans websecretaire, site privé.
        br
        form(role='form' style='max-width: 300px;')
            .form-group
                input.form-control(type='text', name="email", v-model="email" placeholder='Entrer votre email')
            .form-group
                input.form-control(type='password', name="password", placeholder='Password' v-model="password")
            button.btn.btn-default.mr-2(type='submit' @click.prevent="login") Valider 
            a(href='/')
                button.btn.btn-primary(type="button" @click="cancel") Annuler
        div(v-if='$store.state.loginMessage' class="alert alert-warning" role="alert"  style=" height: 40px;")
          p   {{$store.state.loginMessage}}     
</template>
<script>
import AppNav from './AppNav'
export default {
  name: 'login',
  components: {
    AppNav,
  },
  data() {
    return {
      email: '',
      password: '',
      message: ''
    }
  },
  methods: {
    cancel: function () {
          console.log("cancel")
    },
    login: function () {
      const formData = {
        email: this.email,
        password: this.password,
      }
      this.$store.dispatch('login', {vm: this, email: formData.email, password: formData.password})
    },
  }
}
</script>




// WEBPACK FOOTER //
// login.vue?7422cec6